<template>
  <div
    class="app"
    :class="`current-scene-${currentScene}`"
  >
    <h1>Public Relations Specialist</h1>
    <div class="stage">
      <div class="stage__padding">
        <div class="stage__inner">
          <button
            class="mute"
            :class="{
              'muted': muted
            }"
            @click="toggleMute()"
          >toggle mute</button>
          <button
            class="scene__nav scene__nav--next button"
            @click="nextScene()"
            v-if="currentScene ===5"
          >
            <span class="scene__nav-inner">{{ nextButtonText }}</span>
          </button>
          <button
            class="scene__begin button"
            @click="begin()"
            v-if="beginButton"
          >Begin</button>
          <div
            class="scene scene-1"
            :class="{
              'active': currentScene === 1,
              'active-play': currentScene === 1 && !beginButton
            }"
          >
            <div class="scene-1__elevator-door-closed-left"
              :class="{
                'active': currentScene === 1 && trackTime < 2.5
              }"
            ></div>
            <div class="scene-1__elevator-door-closed-right"              
              :class="{
                'active': currentScene === 1 && trackTime < 2.5
              }"
            ></div>
            <div class="scene-1__elevator-door-left"              
              :class="{
                'active': currentScene === 1 && trackTime >= 2.5,
                'movedoors': currentScene === 1 && trackTime >= 2.6
              }"
            ></div>
            <div class="scene-1__elevator-door-right"              
              :class="{
                'active': currentScene === 1 && trackTime >= 2.5,
                'movedoors': currentScene === 1 && trackTime >= 2.6
              }"
            ></div>
            <div class="scene-1__elevator"></div>
            <div class="scene-1__elevator-numbers">
              <p>B</p>
              <p
                :class="{
                  'yellow': currentScene === 1 && trackTime >= 2
                }"
              >1</p>
              <p
                :class="{
                  'yellow': currentScene === 1 && trackTime >= 1 && trackTime < 2
                }"
              >2</p>
              <p
                :class="{
                  'yellow': currentScene === 1 && trackTime >= 0 && trackTime < 1
                }"
              >3</p>
            </div>
            <button 
              class="scene-1__next-scene"
              :class="{
                'active': currentScene === 1 && trackTime >= 4.5
              }"
              @click="nextScene()"
            >Enter</button>
            <div 
              class="scene-1__text"
              :class="{
                'active': currentScene === 1 && trackTime >= 4.5
              }"
            >
              <p>Welcome! We have been waiting for you.</p>
              <p>Click ENTER to open the Public Relations door.</p>
            </div>
          </div>
          <div
            class="scene scene-2"
            :class="{
              'active': currentScene === 2
            }"
          >
            <p class="scene__intro">The <span>Kids Work!</span> Hospital needs a new slogan.  A slogan is a sentence, phrase or word used to describe the goals of an organization.</p>
            <p class="scene-2__rotator care"
              :class="{
                'active': currentScene === 2 && trackTime%3<1
              }"
            >We care about our patients!</p>
            <p class="scene-2__rotator believe"
              :class="{
                'active': currentScene === 2 && trackTime%3>=1 && trackTime%3<2
              }"
            >Care you can believe in.</p>
            <p class="scene-2__rotator know"
              :class="{
                'active': currentScene === 2 && trackTime%3>=2 && trackTime%3<3
              }"
            >From the moment you enter you KNOW this is a special place.</p>
            <button class="button" @click="nextScene()">Create a Slogan</button>
            <p class="scene-2__hospital">Hospital</p>
          </div>
          <div
            class="scene scene-3"
            :class="{
              'active': currentScene === 3
            }"
          >
            <p class="scene__intro">The Public Relations Specialist looks at the photos to get ideas. The selected photo will be used in a newspaper ad with the new slogan. Choose a photo below.</p>
            <div class="scene-3__options-container">
              <div class="scene-3__options choice-1" @mouseover="boxImageValue = 'choice-1'" @focus="boxImageValue = 'choice-1'">
                <div class="scene-3__options__choice-image-display choice-1-thumb"></div>
                <button class="button" @click="nextScene()" @focus="boxImageValue = 'choice-1'">Select Photo</button>
              </div>
              <div class="scene-3__options choice-2" @mouseover="boxImageValue = 'choice-2'" @focus="boxImageValue = 'choice-2'">
                <div class="scene-3__options__choice-image-display choice-2-thumb"></div>
                <button class="button" @click="nextScene()" @focus="boxImageValue = 'choice-2'">Select Photo</button>
              </div>
              <div class="scene-3__options choice-3" @mouseover="boxImageValue = 'choice-3'" @focus="boxImageValue = 'choice-3'">
                <div class="scene-3__options__choice-image-display choice-3-thumb"></div>
                <button class="button" @click="nextScene()" @focus="boxImageValue = 'choice-3'">Select Photo</button>
              </div>
              <div class="scene-3__options choice-4" @mouseover="boxImageValue = 'choice-4'" @focus="boxImageValue = 'choice-4'">
                <div class="scene-3__options__choice-image-display choice-4-thumb"></div>
                <button class="button" @click="nextScene()" @focus="boxImageValue = 'choice-4'">Select Photo</button>
              </div>
            </div>
            <div class="scene__right-box">
              <p class="scene__right-box__headline">Kids Work! Hospital</p>
              <div class="scene__right-box-image" :class="boxImageValue + '-color'"></div>
            </div>
          </div>
          <div
            class="scene scene-4"
            :class="{
              'active': currentScene === 4
            }"
          >
            <p class="scene__intro">Now the Public Relations Specialist will write a slogan.  Create an attention-getting phrase or sentence to go with the photo.  Press ENTER when you are finished.</p>
            <div class="scene-4__left-box">
              <form @submit.prevent="onSubmit">
                <label for="slogan">Type slogan below:</label>
                <textarea class="slogan-input" id="slogan" ref="sloganfield" maxlength="110" />
                <input class="button" type="submit" value="Enter Slogan">
              </form>
            </div>
            <div class="scene__right-box">
              <p class="scene__right-box__headline">Kids Work! Hospital</p>
              <div class="scene__right-box-image" :class="boxImageValue + '-color'"></div>
              <p class="scene__right-box__slogan color">{{ slogan }}</p>
            </div>
          </div>
          <div
            class="scene scene-5"
            :class="{
              'active': currentScene === 5
            }"
          >
            <p class="scene__intro">The newspaper ad is complete.  One thousand <span>Kids Work!</span> Times subscribers will see the new slogan in their Sunday paper.</p>
            <div class="scene-5__left-box"></div>
            <div class="scene__right-box">
              <p class="scene__right-box__headline">Kids Work! Hospital</p>
              <div class="scene__right-box-image" :class="boxImageValue + '-bw'"></div>
              <p class="scene__right-box__slogan">{{ slogan }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: 'app',
  data() {
    return {
      slogan: 'Slogan goes here', 
      boxImageValue: 'placeholder'
    }
  },
  computed: {
    ...mapState([
      'numScenes',
      'currentScene',
      'beginButton',
      'muted',
      'trackTime'
    ]),
    nextButtonText () {
      if (this.currentScene < this.numScenes) {
        return 'Next'
      } else {
        return 'End'
      }
    }
  },
  methods: {
    ...mapMutations([
      'HIDE_BEGIN_BUTTON',
      'RESET_TRACK_INTERVAL'
    ]),
    ...mapActions([
      'begin',
      'previousScene',
      'nextScene',
      'toggleMute'
    ]),
    onSubmit() {
      this.slogan = this.$refs.sloganfield.value;
      this.nextScene();
    }
  }
}
</script>

<style lang="scss">
body {
  background-color: #FFF;
}
</style>
